import { useEffect } from "react";

export default function Modal({
    open,
    title,
    onClose,
    children,
    maxWidth = "max-w-3xl",
    bodyClass = "p-4",     // para no romper tu layout actual
}) {
    useEffect(() => {
        if (!open) return;

        // cerrar con ESC
        const onKey = (e) => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", onKey);

        // bloquear scroll del body
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prev || "";
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[70]">
            {/* Fondo gris: clic cierra */}
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            {/* Contenedor centrado */}
            <div className="absolute inset-0 overflow-y-auto">
                <div className="min-h-full flex items-start sm:items-center justify-center p-4">
                    <div className={`w-full ${maxWidth} bg-white rounded-xl shadow-xl`} onClick={(e) => e.stopPropagation()}>
                        <div
                            className="fixed inset-0 z-[70]"
                            role="dialog"
                            aria-modal="true"
                            onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
                        >
                            {/* Overlay (no captura eventos) */}
                            <div className="absolute inset-0 bg-black/40 pointer-events-none" />

                            {/* Contenedor centrado */}
                            <div className="absolute inset-0 overflow-y-auto">
                                <div className="min-h-full flex items-start sm:items-center justify-center p-4">
                                    <div
                                        className={`relative z-10 w-full ${maxWidth} bg-white rounded-xl shadow-xl`}
                                        onMouseDown={(e) => e.stopPropagation()}  // ⬅️ evita que burbujee al wrapper
                                    >
                                        <div className="flex items-center justify-between p-4 border-b">
                                            <h3 className="text-base font-semibold text-gray-800">{title}</h3>
                                            <button onClick={onClose} className="p-1.5 rounded hover:bg-gray-100">…</button>
                                        </div>
                                        <div className={bodyClass}>{children}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}